










































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import { IPerRoadSeasonImperial, IPerRoadSeasonMetric } from '@/modules/perRoad/interfaces/perRoad';

@Component({
  components: {
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class SeasonRow extends Vue {
  @Prop() season!: IPerRoadSeasonImperial | IPerRoadSeasonMetric;

  @Prop() validations!: any;

  get key() {
    return this.season.id;
  }

  sync() {
    this.$emit('sync');
  }

  get unitSystemIsImperial() {
    return this.season.unitSystem === UnitSystem.Imperial;
  }
}
